import Fetch from 'fetch';
import { setBrandingVars } from '../utils/BrandingUtils';
import defaultBranding from './defaultModernBranding.json';

export const getModernBranding = (diId) => {
    const { pathname } = window.location;
    let region = 'live';

    if (pathname.indexOf('/beta/') !== -1) {
        region = 'beta';
    }

    const url = `/nxg-olb-bff/${region}/nxg-ui/v1/brandings`;

    Fetch.get(url, { type: 'legacy' }, { institutionId: diId })
        .then((data) => {
            setBrandingVars(data.themes.light);
        })
        .catch((err) => {
            console.error(err);
            setBrandingVars(defaultBranding);
        });
};
